
/**
 * @fileOverview GSN Column Content View
 * @modified 10/31/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/GSNColumnView',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

		var gsnColumnView = function($columnList){
			this.columnList = $columnList;
			this.columnItems = [];
			this.desktopSplit = [];
			this.tabletSplit = [];

			$debug('Initializing GSN Column View for:', 'gsnColumnView');
			$debug(this.columnList, 'gsnColumnView');

			this.init();
		};

		gsnColumnView.prototype.init = function(){
			var listLength = this.getLength(this.columnList);
			var siblings = this.getSiblings(this.columnList);

			$debug('    Column list length: ' + listLength, 'gsnColumnView');

			if(listLength > 5 || siblings > 0){
				$debug('    List has at least 6 items or has sibling lists, separating into columns...', 'gsnColumnView');

				this.columnItems = this.getListItems(this.columnList);
				this.desktopSplit = this.getSplitValues(this.columnItems, 3);
				this.tabletSplit = this.getSplitValues(this.columnItems, 2);
				this.createSortedList(this.columnItems, this.desktopSplit, 'MMM--isOnDesktop');
				this.createSortedList(this.columnItems, this.tabletSplit, 'MMM--isOnTablet');
			} else{
				$debug('    List consisted of less than 6 items, leaving in single column format...', 'gsnColumnView');

				this.columnList.removeClass('MMM--columnListGSN');
			}
		};

		gsnColumnView.prototype.getLength = function($columnList){
			var length = 0;
			// Set up the list of items that need to be split
			$columnList.find('li').each(function(){
				// Ignore any mobile-only list items
				if(!$(this).hasClass('MMM--isOnMobile')){
					length++;
				}
			});

			return length;
		};

		gsnColumnView.prototype.getSiblings = function($columnList){
			var siblings = $columnList.parent().siblings('li').find('.MMM--gsnSubMenu').length;
			return siblings;
		};

		gsnColumnView.prototype.getListItems = function($columnList){
			var listItems = [];
			// Set up the list of items that need to be split
			$columnList.find('li').each(function(){
				// Ignore any mobile-only list items
				if(!$(this).hasClass('MMM--isOnMobile')){
					listItems.push($(this).clone());
					// The existing list items should be mobile only
					$(this).addClass('MMM--isOnMobile MMM--isNotOnTablet');
				}
			});
			return listItems;
		};

		gsnColumnView.prototype.getSplitValues = function(columnItems, columns){
			var splits = [],
				columnLength = columnItems.length;
			// Determine the thresholds for where the list splits
			for(var i=0;i<columns;i++){
				splits[i] = (i+1)*columnLength/columns;
			}
			return splits;
		};

		gsnColumnView.prototype.createSortedList = function(columnItems, splitValues, listClass){
			var self = this;
			// Create a new column for each value in the splitValues (3 for desktop, 2 for tablet)
			$.each(splitValues, function(i){
				var $container = $('<ul class="' + listClass + ' MMM--sortedColumn '+listClass+'-'+i+'-gsn"></ul>'),
					lowerLimit = !!splitValues[i-1] ? splitValues[i-1] : 0;
				$.each(columnItems, function(j){
					// If the index is less than the current split threshold, place it in the list
					if(j >= lowerLimit && j < splitValues[i]){
						$container.append(columnItems[j].clone());
					}
				});
				self.columnList.append($container);
			});
			return this;
		};
		return gsnColumnView;
	});
}(MMMRequire));